import { Catalog } from '@/types/Catalog';
import { createAsyncThunk } from '@/redux/createAsyncThunk';
import { getAuthToken } from '@/redux/modules/user';
import { getDeployment } from '@/redux/modules/config';
import { postFetchCatalogsByIds } from '@/redux/modules/catalog/catalog.api';
import { whichCatalogsNeeded } from '@/redux/modules/catalog/catalog.selectors';

/**
 * @deprecated If using toolkit, use fetchCatalogs.fulfilled instead
 */
export const LOAD_CATALOGS_SUCCESS = 'la/domain/catalogs/LOAD_SUCCESS';

type FetchCatalogsParams = {
    catalogIds: number[];
    forceNoCache?: boolean;
};

export const fetchCatalogs = createAsyncThunk<Catalog[], FetchCatalogsParams>(
    'la/ui/catalog/fetchCatalogs',
    async ({ catalogIds, forceNoCache = false }, { dispatch, getState }) => {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        const response = await postFetchCatalogsByIds({
            authToken,
            catalogIds,
            deployment,
            forceNoCache,
        });
        dispatch({
            meta: { actionTime: Date.now(), catalogIds },
            payload: response.data,
            type: LOAD_CATALOGS_SUCCESS,
        });
        return response.data.catalogs;
    }
);

export const fetchCatalogsIfNeeded = createAsyncThunk<void, number[]>(
    'la/ui/catalog/fetchCatalogsIfNeeded',
    async (catalogIds, { dispatch, getState }) => {
        const state = getState();
        const needed = whichCatalogsNeeded(state, catalogIds);
        if (needed.length) {
            await dispatch(fetchCatalogs({ catalogIds: needed }));
        }
    }
);
